import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[locktonAppsClearOnFocus]',
  standalone: true,
})
export class ClearOnFocusDirective implements OnInit, OnDestroy {
  @Input() locktonAppsClearOnFocus!: 'zero' | 'always' | 'disabled';

  private readonly destroyer$: Subject<void> = new Subject();
  private cachedValue!: string;

  constructor(private hostElement: ElementRef) {}

  ngOnInit(): void {
    if (
      this.locktonAppsClearOnFocus &&
      this.locktonAppsClearOnFocus !== 'disabled'
    ) {
      this.listenToEvents();
    }
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  private listenToEvents(): void {
    this.addEventListener('focus', this.onFocus);
    this.addEventListener('blur', this.onBlur);
  }

  private addEventListener(event: string, handler: () => void) {
    fromEvent(this.hostElement.nativeElement, event)
      .pipe(takeUntil(this.destroyer$))
      .subscribe(handler.bind(this));
  }

  private onFocus(): void {
    this.cachedValue = this.hostElement.nativeElement.value;

    switch (this.locktonAppsClearOnFocus) {
      case 'zero':
        if (parseFloat(this.hostElement.nativeElement.value) === 0) {
          this.hostElement.nativeElement.value = '';
        }
        return;

      case 'always':
      default:
        this.hostElement.nativeElement.value = '';
    }
  }

  private onBlur(): void {
    if (!this.hostElement.nativeElement.value) {
      this.hostElement.nativeElement.value = this.cachedValue;
    }
  }
}
